//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";

export default {
  name: "CategoryCollectionsFilterSearch",
  components: {
    Button: () => import("@/components/common/Button"),
    InputComponent: () => import("@/components/common/InputComponent")
  },
  computed: {
    ...mapGetters({
      entity: 'pages/category-collections/entity',
      query: 'pages/category-collections/query',
    })
  },
  methods: {
    search() {
      if (this.query) {
        this.$store.dispatch('pages/category-collections/search')
      }
    },
    reset() {
      this.$store.commit('pages/category-collections/setQuery', '')
      this.$store.commit('pages/category-collections/clear')
    }
  }
}
